import axios from 'axios'
import { Configuration, FeatureFlagsApi } from '@invitae/stargate'
import { NVTA_ENV } from 'config'

const TOGGLE_APP_NAME = 'cii auth microfrontend'
const TOGGLE_PROJECT_NAME = 'cii-patient-app'

function getStargateFeatureFlagClient() {
  const axiosInstance = axios.create()

  let basePath

  if (NVTA_ENV === 'prd') {
    basePath = 'https://www.invitae.com/api-gw'
  } else {
    basePath = `https://invitae.${NVTA_ENV}.locusdev.net/api-gw`
  }

  const config = new Configuration({ basePath })

  return new FeatureFlagsApi(config, undefined, axiosInstance)
}

function isFlagEnabled(flags, flagName) {
  const flag = flags?.find(f => f.name === flagName)
  return flag?.enabled
}

function getFeatureFlags() {
  try {
    const modularOnboardingFlag = 'modular-onboarding'
    const redirectToPatientAppFlag = 'redirectToPatientAppEnabled'

    return getStargateFeatureFlagClient()
      .getFeatureFlags({
        flagNames: [modularOnboardingFlag, redirectToPatientAppFlag],
        appName: TOGGLE_APP_NAME,
        projectName: TOGGLE_PROJECT_NAME
      })
      .then(res => {
        return {
          modularOnboardingFlag: isFlagEnabled(
            res?.data?.featureFlags || [],
            modularOnboardingFlag
          ),
          redirectToPatientAppFlag: isFlagEnabled(
            res?.data?.featureFlags || [],
            redirectToPatientAppFlag
          )
        }
      })
  } catch (err) {
    console.error('error fetching feature flag, ', err)
    return false
  }
}

export default getFeatureFlags
